import { type ReactNode, createContext, useContext, useMemo } from "react";
import { getAccountId, useUserInfoStore } from "@helium10/re-core";
import { isPlainObject } from "lodash-es";

const WHITELIST_KEY = "DOCUMENT_CENTER_WHITELIST";

const fixedWhiteList = {
  emails: [
    "medicube.official@gmail.com",
    "brandon@hidranur.com",
    "sales@prinics.com",
    "elisabeth.monaghan@disney.com",
    "clara.millequant@karo.com",
    "mf@biogaia.us",
    "tds.amazonbrand@disney.com",
    "admin.software@scale.tech",
    "amazon@hellocake.com",
    "scott@year5now.com",
    "gilad@sereniko.com",
    "nhinton@elbertmountain.com",
    "jonathan.stephens@audioadvice.com",
    "amazon@pryzma.co",
  ],
  accountIds: [
    "1546943551",
    "1546084027",
    "1543479974",
    "1546865994",
    "1544296661",
    "1545768847",
    "1546811058",
    "1543027087",
    "2128523760",
    "1543382286",
    "1543646260",
    "1527774283",
    "1545319697",
    "1525192599",
    "1543265037",
  ],
};

type IWhiteList = typeof fixedWhiteList;

const getWhiteList = (): IWhiteList => {
  try {
    const stored = localStorage.getItem(WHITELIST_KEY);
    if (stored && isPlainObject(JSON.parse(stored))) {
      return JSON.parse(stored) as IWhiteList;
    }
  } catch {
    localStorage.removeItem(WHITELIST_KEY);
  }
  return fixedWhiteList;
};

const whiteList = getWhiteList();

const isEmailInWhiteList = (email?: string) =>
  !!email && whiteList.emails.some((item) => email === item);

const isAccountIdInWhiteList = (accountId?: string) =>
  !!accountId && whiteList.accountIds.some((item) => item === String(accountId));

interface IDocumentCenterWhitelistContext {
  isDocumentCenterWhitelisted: boolean;
}

const DocumentCenterWhitelistContext = createContext<IDocumentCenterWhitelistContext | null>(null);

export const useDocumentCenterWhitelist = () => {
  const ctx = useContext(DocumentCenterWhitelistContext);
  return ctx?.isDocumentCenterWhitelisted ?? false;
};

export const DocumentCenterWhitelistProvider = ({ children }: { children: ReactNode }) => {
  const email = useUserInfoStore((s) => s.userInfo?.results?.email);
  const accountId = getAccountId();

  const isDocumentCenterWhitelisted = useMemo(
    // () => isEmailInWhiteList(email) || isAccountIdInWhiteList(accountId as string),
    () => true,
    [email, accountId],
  );

  const value = useMemo(() => ({ isDocumentCenterWhitelisted }), [isDocumentCenterWhitelisted]);

  return (
    <DocumentCenterWhitelistContext.Provider value={value}>
      {children}
    </DocumentCenterWhitelistContext.Provider>
  );
};
